module.exports = __webpack_public_path__ + "img/jose-exile.51f42bad.png";